export { default } from "./related-item-heading";
